// extracted by mini-css-extract-plugin
module.exports = {"ButtonGroup":"Footer__ButtonGroup___ISsK9","Button":"Footer__Button___3y-ik"};